const actions = {
    CUSTOMERGROUP_DETAILS_START: 'CUSTOMERGROUP_DETAILS_START',
    CUSTOMERGROUP_DETAILS_SUCCESS: 'CUSTOMERGROUP_DETAILS_SUCCESS',
    CUSTOMERGROUP_DETAILS_FAILURE: 'CUSTOMERGROUP_DETAILS_FAILURE',

    CLEAR_SALES_SETUP_DETAILS_START: 'CLEAR_SALES_SETUP_DETAILS_START',
    CLEAR_SALES_SETUP_DETAILS_SUCCESS: 'CLEAR_SALES_SETUP_DETAILS_SUCCESS',

    POS_SETUP_DETAILS_START: 'POS_SETUP_DETAILS_START',
    POS_SETUP_DETAILS_SUCCESS: 'POS_SETUP_DETAILS_SUCCESS',
    POS_SETUP_DETAILS_FAILURE: 'POS_SETUP_DETAILS_FAILURE',

    CPRODUCT_DETAILS_START: 'CPRODUCT_DETAILS_START',
    CPRODUCT_DETAILS_SUCCESS: 'CPRODUCT_DETAILS_SUCCESS',
    CPRODUCT_DETAILS_FAILURE: 'CPRODUCT_DETAILS_FAILURE',

    POS_SETUP_USERS_START: 'POS_SETUP_USERS_START',
    POS_SETUP_USERS_SUCCESS: 'POS_SETUP_USERS_SUCCESS',
    POS_SETUP_USERS_FAILURE: 'POS_SETUP_USERS_FAILURE'
};

export default actions;